"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconBacktotop = void 0;
var React = __importStar(require("react"));
var IconBacktotop = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M18.707,10.293 L12.707,4.293 C12.316,3.902 11.684,3.902 11.293,4.293 L5.293,10.293 C4.902,10.684 4.902,11.316 5.293,11.707 C5.488,11.902 5.744,12 6,12 C6.256,12 6.512,11.902 6.707,11.707 L11,7.414 L11,19 C11,19.553 11.448,20 12,20 C12.552,20 13,19.553 13,19 L13,7.414 L17.293,11.707 C17.488,11.902 17.744,12 18,12 C18.256,12 18.512,11.902 18.707,11.707 C19.098,11.316 19.098,10.684 18.707,10.293" }))); };
exports.IconBacktotop = IconBacktotop;
exports.IconBacktotop.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconBacktotop;
